module.exports = __webpack_public_path__ + "img/bulletedList_b.94cc338a.svg";